import { render, staticRenderFns } from "./gameResultSlotsTab.vue?vue&type=template&id=5a9b302a&lang=pug"
import script from "./gameResultSlotsTab.vue?vue&type=script&lang=js"
export * from "./gameResultSlotsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports